import React, { useEffect, useState } from "react";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CheckIcon from "@material-ui/icons/Check";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import { connect, shallowEqual, useSelector } from "react-redux";

function FLMultiSelect(props) {
  const { filters } = useSelector((state) => ({
    filters: state.advert.newAdvert.filters,
  }));

  const handleChange = (event) => {
    const { name, value } = event.target;
    props.editNewAdvertFilters(name, value);
  };

  const selected = filters[props.filter.slug] || [];

  return (
    <div>
      <FormControl variant="outlined" fullWidth={true} margin="dense">
        <InputLabel id={`${props.filter.slug}-label`}>
          {props.filter.title}
        </InputLabel>
        <Select
          multiple
          name={props.filter.slug}
          labelId={`${props.filter.slug}-label`}
          id={props.filter.slug}
          label={props.filter.title}
          value={selected}
          onChange={handleChange}
          renderValue={(vals) => (Array.isArray(vals) ? vals.join(", ") : vals)}
          MenuProps={{
            getContentAnchorEl: null,
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            transformOrigin: { vertical: "top", horizontal: "left" },
          }}
        >
          {props.filter.values.map((item, index) => {
            const isSelected = selected.includes(item);
            return (
              <MenuItem
                value={item}
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: isSelected ? "#e6f9f1" : "transparent",
                  color: isSelected ? "#0d7a58" : "#222",
                  fontWeight: isSelected ? 700 : 400,
                }}
              >
                {item}
                {isSelected && (
                  <CheckIcon fontSize="small" style={{ color: "#1ec28b" }} />
                )}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  );
}

export default connect(null, { ...advertRedux.actions })(FLMultiSelect);
